import Swiper from 'swiper/swiper-bundle.esm.js';

class SliderImageText {
  public component;
  public trigger;
  constructor() {
    this.component = document.querySelectorAll(
      '[data-component="client-interactivite"]'
    );
    this.trigger = document.querySelectorAll(
      '[data-trigger="client-interactivite"]'
    );

    if (this.component && this.trigger) {
      this._init();
    }
  }
  _init() {
    this.trigger.forEach((element) => {
      let mySwiper: Swiper = null;

      const firstImage = element.querySelector('img');

      if (firstImage) {
        firstImage.onload = () => {
          console.log('OK');
          if (mySwiper) {
            mySwiper.update();
          }
        };
      }

      mySwiper = new Swiper(element, {
        grabCursor: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        effect: 'creative',
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ['-20%', 0, -1]
          },
          next: {
            translate: ['100%', 0, 0]
          }
        },
        preloadImages: false,
        slidesPerView: 1,
        lazy: {
          loadOnTransitionStart: true
        }
      });
    });
  }
}

export const sliderImageText = new SliderImageText();
